import type { FC } from 'react';
import React from 'react';

import iconSrc from '@wwe-portal/ui/assets/images/subscription/coming_soon.webp';

export type ComingSoonImgProps = React.ReactComponentElement<'img'>['props'];
export const ComingSoonImg: FC<ComingSoonImgProps> = (props) => {
  return <img alt="Add Club Coin" src={iconSrc} {...props} />;
};
